import { defineComponent as _defineComponent } from 'vue'
import CreateEventCancel from '@/pages/CreateEventProcessingPage/ui/CreateEventCancel.vue'
// @ts-expect-error Not a ts file
import store from '@/store'
import { eventApi, EventDB } from '@/enitites/event'
import { computed, inject, ref } from 'vue'
import { useImage } from '@/shared/composables/image'
import { mdiLeadPencil, mdiMinusCircleOutline, mdiPlus, mdiUpload } from '@mdi/js'
import { EventCarpet } from '@/enitites/event/model/types'
import { CreateEventFormName } from '../model/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateEventDisplayMode',
  props: {
    isNew: { type: Boolean, default: true },
    eventData: null,
    backStep: { type: Boolean, default: false },
    screen: null
  },
  emits: ["updateEvent", "update:screen", "saveAsDraft"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'updateEvent'): void
  (e: 'update:screen', value: CreateEventFormName): void
  (e: 'saveAsDraft'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isNew: boolean, eventData: EventDB, backStep: boolean, screen: CreateEventFormName };

const { getImageById, saveImage } = useImage()




const srcScoreboardBgImage = ref(
  props.eventData.scoreboardBgImage ? getImageById(props.eventData.scoreboardBgImage, 800, 450) : ''
)
const srcLogo = ref(props.eventData.scoreboardLogo ? getImageById(props.eventData.scoreboardLogo, 800, 800) : '')
const isShowImg = ref(props.backStep)
const filesLogoEvent = ref<FileList | null>(null)
const filesBgImageEvent = ref<FileList | null>(null)
const loadingNextBtn = ref(false)
const currentDotNav = ref(4)
const error = ref(null)
const inputBgImageRef = ref<HTMLInputElement | null>(null)
const inputLogoRef = ref<HTMLInputElement | null>(null)
const eventCarpets = ref<EventCarpet[]>(props.eventData.carpets || [])
const isUpdatingCarpets = ref(false)

const isInfoFilledOut = computed(() => !!props.eventData.title)

async function setBgImageToEvent() {
  if (!filesBgImageEvent.value?.[0]) return
  props.eventData.scoreboardBgImage = await saveImage(filesBgImageEvent.value[0])
  isShowImg.value = true
}

async function setLogoToEvent() {
  if (!filesLogoEvent.value?.[0]) return
  props.eventData.scoreboardLogo = await saveImage(filesLogoEvent.value[0])
  isShowImg.value = true
}

async function saveAsDraft() {
  if (filesBgImageEvent.value) await setBgImageToEvent()
  if (filesLogoEvent.value) await setLogoToEvent()

  emit('saveAsDraft')
  loadingNextBtn.value = false
}

async function handleAddCarpet() {
  const id = 0
  const newCarpetIndex = eventCarpets.value.length + 1
  eventCarpets.value.push({
    id,
    name: `Carpet ${newCarpetIndex}`,
  })
}

async function handleRemoveCarpet(index: number) {
  eventCarpets.value = eventCarpets.value.filter((_, i) => i !== index)
}

async function handleUpdateCarpetName(index: number, name: string) {
  eventCarpets.value[index].name = name
}

async function updateCarpets() {
  if (isUpdatingCarpets.value) return
  isUpdatingCarpets.value = true

  try {
    await eventApi.updateEventCarpets(props.eventData.id, eventCarpets.value)
  } catch (error) {
    console.error('Error updating carpets:', error)
  } finally {
    isUpdatingCarpets.value = false
  }
}

const isInitializingScoreboards = ref(false)
async function initScoreboards() {
  if (isInitializingScoreboards.value) return
  isInitializingScoreboards.value = true

  try {
    const data = await eventApi.initEventScoreboards(props.eventData.id)
    if (data) {
      console.log('Scoreboards initialized:', data)
    }
  } catch (error) {
    console.error('Error initializing scoreboards:', error)
  } finally {
    isInitializingScoreboards.value = false
  }
}

const injectedIsClickBtnNext = inject<{
  updateIsClickBtnNext: (value: boolean) => void
}>('isClickBtnNext')

async function handlerClickNext() {
  error.value = null
  loadingNextBtn.value = true

  if (filesBgImageEvent.value) await setBgImageToEvent()
  if (filesLogoEvent.value) await setLogoToEvent()
  if (eventCarpets.value.length) {
    await updateCarpets()
    await initScoreboards()
  }

  emit('updateEvent')
  loadingNextBtn.value = false
  injectedIsClickBtnNext?.updateIsClickBtnNext(true)

  emit('update:screen', props.backStep ? 'CreateEventTotal' : 'CreateEventBattles')
}

function openBgImageDialog() {
  inputBgImageRef.value?.click()
}

function handlerBgImageChange(evt: Event) {
  const filesImg = (evt.target as HTMLInputElement).files
  if (!filesImg?.length) return

  const reader = new FileReader()
  reader.onload = (event) => {
    srcScoreboardBgImage.value = event.target?.result as string
    filesBgImageEvent.value = filesImg
  }
  reader.readAsDataURL(filesImg[0])
}

function openLogoDialog() {
  inputLogoRef.value?.click()
}

function handlerLogoChange(evt: Event) {
  const filesImg = (evt.target as HTMLInputElement).files
  if (!filesImg?.length) return

  const reader = new FileReader()
  reader.onload = (event) => {
    srcLogo.value = event.target?.result as string
    filesLogoEvent.value = filesImg
  }
  reader.readAsDataURL(filesImg[0])
}

function handlerClickBack() {
  injectedIsClickBtnNext?.updateIsClickBtnNext(false)
  emit('update:screen', 'CreateEventTiers')
}

function handlerClickCancelEdit() {
  emit('update:screen', 'CreateEventTotal')
}

return { __sfc: true,getImageById, saveImage, props, emit, srcScoreboardBgImage, srcLogo, isShowImg, filesLogoEvent, filesBgImageEvent, loadingNextBtn, currentDotNav, error, inputBgImageRef, inputLogoRef, eventCarpets, isUpdatingCarpets, isInfoFilledOut, setBgImageToEvent, setLogoToEvent, saveAsDraft, handleAddCarpet, handleRemoveCarpet, handleUpdateCarpetName, updateCarpets, isInitializingScoreboards, initScoreboards, injectedIsClickBtnNext, handlerClickNext, openBgImageDialog, handlerBgImageChange, openLogoDialog, handlerLogoChange, handlerClickBack, handlerClickCancelEdit, CreateEventCancel, store, mdiLeadPencil, mdiMinusCircleOutline, mdiPlus, mdiUpload }
}

})